import { z } from 'zod';

/** UUID v4 produced by `crypto.randomUUID()` — the format every `id` column uses. */
export const uuidSchema = z.string().uuid();

/** Timestamps are unix-ms integers in D1; serialised as numbers over the wire. */
export const timestampMsSchema = z.number().int().nonnegative();

/** URL slug used for organization Vibe Spaces and join codes. */
export const slugSchema = z
  .string()
  .min(2)
  .max(48)
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'lowercase letters, digits, and hyphens only');

/**
 * Email shape — accepts any RFC-valid email and exposes a normalized lowercase
 * copy for case-insensitive matching against `profiles.email_normalized`.
 */
export const emailSchema = z
  .string()
  .trim()
  .email()
  .max(254)
  .transform((s) => s.toLowerCase());

/** Standard error envelope every API endpoint returns on failure. */
export const apiErrorSchema = z.object({
  error: z.string(),
  message: z.string().optional(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
